import { jsx as _jsx } from "react/jsx-runtime";
import fuzzy from "fuzzy";
import { createFlattenedArray } from "./utils";
export const formatMatchingText = (haystack, needle, regex) => {
    const values = needle.toLowerCase().split("");
    if (values.length === 0) {
        return haystack;
    }
    return (_jsx("span", { children: haystack.split(regex).reduce((prev, current, i) => {
            if (!i) {
                return [current];
            }
            return prev.concat(values.includes(current.toLowerCase()) ? _jsx("em", { children: current }, `${i}${current}`) : current);
        }, []) }));
};
export const matchingTextReg = /\[\[(.*?)\]\]/gi;
export const updateFilteredOptionLabels = (searchText, searchRegex = matchingTextReg) => (obj) => {
    if (obj.original && typeof obj.original.label === "string") {
        return {
            ...obj.original,
            label: formatMatchingText(obj.string, searchText, searchRegex),
            labelString: obj.original.labelString ? obj.original.labelString : obj.original.label
        };
    }
    if (obj.original && typeof obj.original.label === "function") {
        return obj.original;
    }
    return {
        ...obj.original,
        label: formatMatchingText(obj.string, searchText, searchRegex),
        labelString: obj.original.labelString
    };
};
export const extractLabelString = (option) => {
    if (typeof option.label === "string") {
        return option.label;
    }
    if (typeof option.labelString === "string") {
        return option.labelString;
    }
    return "";
};
export const getFilteredOptionList = ({ currentOptions, options, searchText }) => {
    if (options && searchText && searchText.length > 0) {
        const flatOptions = createFlattenedArray(options);
        const results = fuzzy.filter(searchText, flatOptions.filter((option) => option.shouldExcludeFromFilter !== true), {
            pre: "[[",
            post: "]]",
            extract: extractLabelString
        });
        const excludedOptions = flatOptions.filter((option) => option.shouldExcludeFromFilter === true);
        const hasExcludedOptions = excludedOptions.length > 0;
        if (results.length > 0) {
            const resultsWithUpdatedLabels = results.map(updateFilteredOptionLabels(searchText));
            return hasExcludedOptions
                ? resultsWithUpdatedLabels.concat(flatOptions.filter((option) => option.shouldExcludeFromFilter === true))
                : resultsWithUpdatedLabels;
        }
        return hasExcludedOptions ? excludedOptions : [];
    }
    return currentOptions || options;
};
